export const bannerMotion = {
	initial: 'init',
	animate: 'animate',
	exit: 'exit',
	variants: {
		init: {
			y: '50%',
			opacity: 0,
		},
		animate: {
			y: 0,
			opacity: 1,
		},
		exit: {
			y: '50%',
			opacity: 0,
		},
	},
	transition: {
		type: 'spring',
		duration: 0.5,
	},
};

export const popupMotion = {
	variants: {
		init: {
			y: '15%',
			opacity: 0,
		},
		animate: {
			y: 0,
			opacity: 1,
		},
		exit: {
			y: '15%',
			opacity: 0,
		},
	},
	transition: {
		type: 'spring',
		duration: 0.5,
	},
};

export const dropdownMotion = {
	initial: 'collapsed',
	animate: 'open',
	exit: 'collapsed',
	variants: {
		open: {
			opacity: 1,
			height: 'auto',
		},
		collapsed: {
			opacity: 0,
			height: 0,
		},
	},
	transition: {
		type: 'tween',
		duration: 0.25,
	},
};
export const descriptionMotion = {
	variants: {
		open: {
			opacity: 1,
			scale: 1,
		},
		collapsed: {
			opacity: 0,
			scale: 0.9,
		},
	},
	transition: {
		type: 'tween',
		duration: 0.25,
	},
};
